import { render, staticRenderFns } from "./CollectSuDetail.vue?vue&type=template&id=2adaf99c&scoped=true&"
import script from "./CollectSuDetail.vue?vue&type=script&lang=js&"
export * from "./CollectSuDetail.vue?vue&type=script&lang=js&"
import style0 from "./CollectSuDetail.vue?vue&type=style&index=0&id=2adaf99c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adaf99c",
  null
  
)

export default component.exports